import React from 'react';
import Header from '../Components/Header';
import { Helmet } from 'react-helmet';

const ReviewView = () => {
    // const [reviews, setReviews] = useState([]);
    // const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);

    // useEffect(() => {
    //     const fetchReviews = async () => {
    //         try {
    //             const response = await axios.get(`https://scfpsback.osc-fr1.scalingo.io/api/googlereviews`);

    //             if (response.data.result && response.data.result.reviews) {
    //                 setReviews(response.data.result.reviews);
    //             } else {
    //                 setError('No reviews found');
    //             }
    //         } catch (err) {
    //             setError('An error occurred while fetching the reviews');
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchReviews();
    // }, [placeId]);

    // if (loading) return <p>Loading reviews...</p>;
    // if (error) return <p>{error}</p>;

    return (

        <div>
            <Helmet>
                <title>Avis</title>
                <meta name="description" content="Avis des utilisateurs" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Header title={"Avis"} />
            <div className="elfsight-app-b67e7c27-3d14-4d1b-90e6-c78f53dd93f8 reviews" data-elfsight-app-lazy></div>
        </div>
    );
};

export default ReviewView;